// extracted by mini-css-extract-plugin
export default {"filtersGrid":"NationalSocietyDashboardPage_filtersGrid__oPyhg"};